const hasValue = (state) => {
    if (state) {
        return Boolean(state.value)
    }
    return false;
}
const returnValue = (state) => {
    return state.value
}
const validateEmail = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export {
    validateEmail,
    returnValue,
    hasValue
}


// WEBPACK FOOTER //
// ./src/Components/Services/formHandlers.js